"use client";

import { useState } from "react";
import Image from "next/image";
import Lightbox from "yet-another-react-lightbox";

export default function CakeGallery() {
  const [idx, setIdx] = useState(-1);

  return (
    <>
      <div className="mt-12 grid grid-cols-3 gap-12 lg:flex-row">
        {PHOTOS.map((img, idx) => {
          return (
            <Image
              key={idx}
              width={img.width}
              height={img.height}
              src={img.id}
              alt={img.id}
              className="w-full transition-all duration-500 ease-linear hover:cursor-pointer hover:brightness-90  rounded-[32px]"
              onClick={() => setIdx(idx)}
            />
          );
        })}
      </div>

      <Lightbox
        index={idx}
        slides={SLIDES}
        open={idx >= 0}
        close={() => setIdx(-1)}
      />
    </>
  );
}

const PHOTOS = [
  {
    id: "/gallery/fotografie-dort-01.png",
    width: 1344,
    height: 1344,
  },
  {
    id: "/gallery/fotografie-dort-02.png",
    width: 1344,
    height: 1344,
  },
  {
    id: "/gallery/fotografie-dort-03.png",
    width: 1344,
    height: 1344,
  },
];

const SLIDES = PHOTOS.map((photo) => {
  const width = photo.width * 4;
  const height = photo.height * 4;
  return {
    src: photo.id,
    width,
    height,
  };
});
